import React from "react";
var __jsx = React.createElement;
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
export var LatestUpdateData = function LatestUpdateData(_ref) {
  var dateString = _ref.dateString;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var date = new Date(dateString).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 20,
      fontSize: '80%'
    }
  }, /*#__PURE__*/React.createElement("span", null, t("latest_update", {
    ns: "web_common"
  }), ": "), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, date));
};
export default LatestUpdateData;